import { isNull } from "../../../../../shared/lib/html5-software-library/src/ranj/util/TypeUtil";
import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";

export default class PopupView extends AbstractView {

    constructor(target, languagePack, gameAssets) {
        super(target);
        this._languagePack = languagePack;
        this._gameAssets = gameAssets;

        this._target.gotoAndStop(0);

        this.createButton(this._target.continueButton, this._handleButton.bind(this));
        this.createButton(this._target.cancelButton, this._handleButton.bind(this));

        this._animating = false;

        this._slots = [];
        for (let i = 0; i < 99; i++) {
            const slot = this._target["slot" + i];
            if (!slot) {
                break;
            }
            this._slots.push(slot);
            slot.origX = slot.x;
            slot.origY = slot.y;
        }

        this._addBackground();
    }

    _addBackground() {
        if (!this.bg) {
            this.bg = this._target.addChildAt(new createjs.Shape(), 0);
            const tl = this._target.parent.localToLocal(-800, -1000, this._target);
            const br = this._target.parent.localToLocal(800, 1000, this._target);
            this.bg.graphics.f("rgba(0,0,0,.01)").r(tl.x, tl.y, br.x - tl.x, br.y - tl.y);
            this.bg.addEventListener("click", () => { });
        }        
    }


    /**
     * 
     * @param {String} title 
     * @param {String} body 
     * @param {Array<Object>} buttonParams - Per button: {label:"myLabel", callback:myFunction}. First button is ok button, optional second button is cancel button.
     * @param {String} type - determines frame to show
     */
    setContent(title, body, buttonParams, type = PopupView.GENERIC) {
        this._target.gotoAndStop(type);
        if (!isNull(title)) this._target.titleTextfield.text = title;
        if (!isNull(body)) this._target.bodyTextfield.text = body;

        this._buttons.forEach((button, idx) => {
            button.skin.visible = false;
            const params = buttonParams[idx];
            if (params) {
                button.skin.visible = true;
                button.setLabel(params.label);
                button.callback = params.callback;
            }
        });
    }

    setActors(actorParams) {
        this._slots.forEach(slot => { slot.visible = false; });
        //actorParams: id, skin
        const n = actorParams.length;
        for (let i = 0; i < n; i++) {
            const slot = this._slots[i];
            slot.visible = true;
            const { id, skin: skinId } = actorParams[i]
            const skin = new this._gameAssets[skinId]();
            slot.image.removeAllChildren();
            slot.image.addChild(skin);
            slot.nameTextfield.text = this.getText("actors." + id);
        }
    }

    open(instant = false) {
        if (this._state != State.OPENED) {
            this._target.addChildAt(this.bg, 0);
            this._animateTo(1, State.OPENED, instant);
        }
    }

    close(instant = false) {
        if (this._state != State.CLOSED) {
            this._animateTo(0, State.CLOSED, instant);
        }
    }

    _animateTo(alpha, stateAtEnd, instant) {
        const onComplete = () => {
            this._state = stateAtEnd;
        }
        if (instant) {
            this._target.alpha = alpha;
            onComplete();
        } else {
            createjs.Tween.get(this._target).to({ alpha: alpha }, 100, createjs.Ease.quadOut).call(onComplete);
        }
    }

    _handleButton(e) {
        this.close();
        this._invoke(e.target.callback);
    }

    _invoke(callback) {
        if (!isNull(callback)) {
            callback();
        }
    }
}

PopupView.FAILED = "failure";
PopupView.COMPLETED = "success";
PopupView.GENERIC = "skip";


const State = { CLOSED: 0, CLOSING: 1, OPENING: 2, OPENED: 3 };